import { v4 } from "uuid";
const createConversationId = (componentName) => `${componentName}-${v4()}`;
var conversationId_default = createConversationId;
export {
  createConversationId,
  conversationId_default as default
};
